import { setServerGlobals } from "./setServerGlobals";
setServerGlobals();
//# sourceMappingURL=setupServerGlobals.js.map
